import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'

const homeSlider = (node) => {
    const OPTIONS = {
        align: 'start',
        loop: true,
        breakpoints: {
            '(min-width: 992px)': {
                active: false,
            }
        }
    }
    const viewportNode = node.querySelector('.embla__viewport')

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [Autoplay()])
}

export default homeSlider
